module.exports = "<app-nav *ngIf=\"router.url !== '/ingresar'\"></app-nav>\n<div [ngClass]=\"{ 'content-wrapper': router.url !== '/ingresar' }\">\n    <router-outlet></router-outlet>\n</div>\n\n"


//////////////////
// WEBPACK FOOTER
// ./src/app/app.component.html
// module id = 767
// module chunks = 0